import { useNetworkMutation } from '@/lib/utils/request'

import type { AlertRecord } from './useAllAlerts'

export interface UpdateAlertPayload extends Record<string, unknown> {
  enabled: boolean
  title: string
  emails: string[]
  phoneNumbers: string[]
  templateName: string
  templateVariables: Record<string, number>
  /** Vehicle tag ids. Empty means the alert is global. */
  tags: number[]
}

export const useUpdateAlert = (alertId: string | null) =>
  useNetworkMutation<AlertRecord, UpdateAlertPayload>(
    alertId ? { url: `v1/alerts/${alertId}/`, method: 'patch' } : null,
  )

export interface PatchAlertByIdPayload extends Record<string, unknown> {
  params: { id: string }
  data: UpdateAlertPayload
}

export const usePatchAlert = () =>
  useNetworkMutation<AlertRecord, PatchAlertByIdPayload>({
    url: 'v1/alerts/${params.id}/',
    method: 'patch',
  })
